import { POApprovalStatus } from "types/enum";

import { StatusTypes } from "commonComponents/utilities/Status/StatusDisplay";

export function getPurchaseOrderApprovalStatusText(status: number): string {
    switch (status as POApprovalStatus) {
        case POApprovalStatus.ApprovedBySub:
        case POApprovalStatus.ApprovedInternally:
        case POApprovalStatus.PendingInternallyAssigned:
            return "Approved";
        case POApprovalStatus.DeclinedBySub:
            return "Declined";
        case POApprovalStatus.PendingSubReleased:
            return "Sent";
        case POApprovalStatus.Unreleased:
            return "Draft";
        case POApprovalStatus.Voided:
            return "Voided";
        case POApprovalStatus.PastCompletionDate:
            return "Expired";
        default:
            return "";
    }
}

export function getPurchaseOrderApprovalStatusType(status: number): StatusTypes {
    switch (status as POApprovalStatus) {
        case POApprovalStatus.ApprovedBySub:
        case POApprovalStatus.ApprovedInternally:
        case POApprovalStatus.PendingInternallyAssigned:
            return "success";
        case POApprovalStatus.DeclinedBySub:
        case POApprovalStatus.PastCompletionDate:
        case POApprovalStatus.Voided:
            return "danger";
        case POApprovalStatus.PendingSubReleased:
            return "info";
        default:
            return "";
    }
}
